import { render, staticRenderFns } from "./tsg-scoped-header-checkbox.vue?vue&type=template&id=824f0342"
import script from "./tsg-scoped-header-checkbox.vue?vue&type=script&lang=js"
export * from "./tsg-scoped-header-checkbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports